<template>
  <div id="mudanca-territorio" class="row">
    <div class="col-md-12">
      <div class="filter-select">
        <vue-select
          :options="profissionais"
          label="no_profissional"
          placeholder="Profissionais"
          @input="onChangeProfissional"
        >
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div>
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs" v-model="tabsActive">
        <b-tab title="Lista" active @click="buscarDadosDaLista()">
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="col-lg-12">
              <title-tag
                title="Cidadãos com mudança de território ativa na FCI"
              ></title-tag>
            </div>
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setRed="setRed"
                      @resetarNome="setRed = false"
                    ></Subtitle>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="mudanca_territorio"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros-vuetfy
                  ref="table"
                  :cadastros="displayedCadastros"
                  :data_secretaria_de_saude="data_secretaria_de_saude"
                  :loading="loadingLista"
                  texto_esus_pec="Procedimentos registrados até"
                  :data_esus_pec="data_secretaria_de_saude"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros-vuetfy>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import { dataFields, infoHtml } from './utils.js'
import TitleTag from '@/components/TitleTag.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import utils from '@/mixins/utils.js'

export default {
  name: 'MudancaTerritórioPorProfissional',
  components: {
    PulseLoader,
    Loader,
    Subtitle,
    TabelaCadastrosVuetfy,
    TitleTag,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      tabsActive: 0,
      profissionais: [],
      profissional: '',
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      data_ministerio_da_saude: null,
      populacaoIbge: 0,
      total_de_registros_da_tabela: 0,
      data_secretaria_de_saude: '',
      loadingResultado: false,
      loadingLista: false,
      loadingGrafico: false,
      nomeEquipe: '',
      nomeProfissional: '',
      equipe: '',
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      user: null,
      dataFields: {
        ...dataFields,
      },
      cadastrosOriginais: [],
      setRed: false,
      text: infoHtml,
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    async carregarProfissionais() {
      try {
        let profissionais = await this.$api.get(
          '/app/profissionais/acs/' +
            this.$store.state.cod_ibge +
            '/' +
            this.$store.state.nu_ine
        )
        if (profissionais) {
          this.profissionais = profissionais.data
          this.profissionais.push({
            nu_cpf: 'todos',
            no_profissional: 'TODOS',
          })
        }
      } catch (error) {
        console.log(error)
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.situacao = ''
        this.profissional = event.nu_cpf
        this.nomeProfissional = event.no_profissional
        this.tabsActive = 0
        this.buscarDadosDaLista()
      } else {
        this.situacao = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.profissional = ''
        this.nomeProfissional = ''
        this.tabsActive = 0
        return
      }
    },

    async buscarDadosDaLista() {
      if (this.profissional !== '' && this.profissional !== null) {
        this.loadingLista = true
        try {
          let response = ''
          if (this.profissional != 'todos') {
            response = await Functions.getCadastrosIndividuais(
              this.$store.state.cod_ibge,
              this.profissional
            )
          } else {
            response = await Functions.getCadastrosIndividuaisTodosPorEquipe(
              this.$store.state.cod_ibge,
              this.equipe.nu_ine
            )
          }

          if (response) {
            this.cadastros = response
            this.cadastrosOriginais = response
            this.total_de_registros_da_tabela = response.length
            this.filtros(true, false)
            this.setRed = true
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      }
    },

    async buscarEquipeDoUsuario() {
      //pega a equipe do acs
      let equipe = await this.$api.get(
        '/app/equipe/' +
          this.$store.state.cod_ibge +
          '/' +
          this.$store.state.nu_ine
      )
      if (equipe) {
        this.equipe = equipe.data
        this.nomeEquipe = equipe.data.no_equipe
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.profissional,
        this.nomeProfissional,
        this.data_secretaria_de_saude
      )
    },

    init() {
      this.buscarEquipeDoUsuario()
      this.carregarProfissionais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
